import React ,{useRef}from "react";
import emailjs from '@emailjs/browser';
export default function ContactUs() {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm('service_pdsmp9e', 'template_3fmtk0b', form.current, {
      publicKey: 'qkSrx-s10Spt1bz98',
    }).then(
      () => {
        console.log('SUCCESS!');
      },
      (error) => {
        console.log('FAILED...', error.text);
      },
    );


    e.target.reset();
  };


  return (
    <section className="contact-section">
      <div className="contact-container">
        {/* Left Side */}
        <div className="contact-left">
          <h2>Let’s Help You To Build Your Dream Home!</h2>
          <p>
            Our team works with you to identify your requirements and create a
            solution that you can call yours for life!
          </p>
          <p>
            <strong>Email:</strong> Info@aspirehomes.co ,wwww.aspirehomes.co 
            <strong> Phone:</strong> Amrinder 0451-518-901 , Varinder 0403-235-632
          </p>

          {/* Google Map */}
          <div className="map-container">
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.086347029589!2d-122.4194150846819!3d37.77492927975944!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085808a7c8a1d4b%3A0xa69c9670e83a1b4d!2sSan+Francisco%2C+CA%2C+USA!5e0!3m2!1sen!2sin!4v1600000000000!5m2!1sen!2sin"
              width="100%"
              height="250"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>

        {/* Right Side */}
        <div className="contact-right">
          <h3>Contact Us</h3>
          <form ref={form} onSubmit={sendEmail}>
            
              <input type="text" placeholder="Your Name" name="name" required />
            
            
              <input type="number" placeholder="Your Phone"  name="cell" required />
           
           
              <textarea placeholder="Your Message"  name="msg"required></textarea>
            
            <button type="submit">Send Message</button>
          </form>
        </div>
      </div>
    </section>
  );
}
